import React, { useState } from "react";
import axios from "axios";
import { Button, Modal, Form } from "react-bootstrap";
import { useSelector } from "react-redux";

 function SignedAgrmt(props) {
  const [modalShow, setModalShow] = useState(true);
  const [username, setUserName] = useState("");
  const handleClose = () => setModalShow(false);
  const user = useSelector((state) => state.user);

  let modalData = {
    AgrmtName: username,
  };

  const callUpdateAgrmtApi = async (data) => {
    await axios
      .put(`api/v1/hwts/user/maintenance/useragrmt/${user.account.accountIdentifier}`, data)
      .then((res) => {
        window.location.reload();
        }).catch((err) => console.error(err)
      );    
  };

  const onUserAgrmtFormSubmit = (e) => {
    e.preventDefault();
    callUpdateAgrmtApi(modalData); 
  };

  return (
    <div className="">
      <Modal show={modalShow}>
      <Modal.Header>
        <Modal.Title>Hazardous Waste Tracking System User Agreement</Modal.Title>
      </Modal.Header>
      <Modal.Body>      
      <p>
      Please carefully read our Hazardous Waste Tracking System {" "}
            <a
              href="/documents/HWTS_User_Agreement_November_2022.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              User Agreement
            </a>
            .   By typing your name below and clicking <b>I Agree</b>, you acknowledge that you have read and accept this Agreement.  You must accept the Agreement to obtain HWTS Regulatory access.
          </p>     
        <Form onSubmit={onUserAgrmtFormSubmit}>  
             <Form.Group controlId="formUserName">
               <Form.Label>Type Signature</Form.Label>
               <Form.Control
                 type="text"
                 placeholder="First and Last Name"
                 value={username}
                 onChange={(e) => setUserName(e.target.value)}
               />
             </Form.Group>
             <Button  variant="primary" type="submit" block>
               I AGREE
             </Button>
             <Button variant="secondary" onClick={handleClose} block >CANCEL</Button>
           </Form>
      </Modal.Body>
    </Modal>
    </div>
  );
}

export default SignedAgrmt;
